import React, {
  createRef,
  useEffect,
  useState,
} from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Button, Modal, Space, Tabs, Divider, Card, Row, Col } from "antd";

import {
  AiFillCheckCircle,
  AiFillEdit,
  AiFillCloseSquare,
  AiOutlineInfoCircle,
} from "react-icons/ai";
import {
  MdAttachMoney,
  MdImage,
  MdSearch,
  MdOutlinePriceCheck,
} from "react-icons/md";
import Swal from "sweetalert2";

import { Subject } from "rxjs";
import { useDispatch, useSelector } from "react-redux";
import { fileManagerActions, systemActions } from "../../store";

import ProductInfo from "./ProductInfo";
import ProductPrice from "./ProductPrice";
import ProductSeo from "./ProductSeo";
import ProductMedia from "./ProductMedia";
import ProductDescriptions from "./ProductDescriptions";
import ProductPriceAttribute from "./ProductPriceAttribute";
import ENV from "../../consts/config";
import productApi from "../../api/product/productApi";

const Product = (props) => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const goToPreviousPath = () => {
    navigate(-1);
  };

  const { productItem, edit, id } = props;
  const loadingSubmit = new Subject();
  const back = () => {
    confirm({
      title: "Mọi chỉnh sửa sẽ bị mất ! Tiếp tục quay lại?",
      onOk() {
        goToPreviousPath();
      },
      onCancel() {},
    });
  };

  useEffect(() => {
    dispatch(fileManagerActions.setUrlImageList(productItem?.images));
  }, []);

  const { fileImages } = useSelector((x) => x.fileManager);

  const { TabPane } = Tabs;
  const confirm = Modal.confirm;
  const numberFormCheck = 4;
  const [tabPosition, setTabPosition] = useState("left");
  const [productInfo, setProductInfo] = useState({});
  const [descriptionEditors, setDescriptionEditors] = useState({});
  const [dataCount, setDataCount] = useState(0);
  const [errorTab, setErrorTab] = useState([]);
  const [startSubmit, setStartSubmit] = useState();

  const refInfo = createRef();
  const refPrice = createRef();
  const refAttribute = createRef();
  const refSeo = createRef();

  const dataFormInfo = (data, name) => {
    if (name) {
      const tabs = errorTab.filter((x) => x.name !== name);
      setErrorTab(tabs);
    }
    setProductInfo({ ...productInfo, ...data });
    setDataCount(dataCount + 1);
  };

  useEffect(() => {
    loadingSubmit.subscribe((e) => {
      replaceEditor();
      setStartSubmit(true);
    });
  }, [loadingSubmit]);

  useEffect(() => {
    if (startSubmit && dataCount === numberFormCheck) {
      if (edit) {
        updateProduct();
      } else {
        createdProduct();
      }
    }
  }, [startSubmit]);

  useEffect(() => {
    if (dataCount === numberFormCheck) {
      loadingSubmit.next();
    }
  }, [dataCount]);

  const setLoading = (status) => {
    dispatch(systemActions.setLoadingSystem(status));
  };

  const descriptionForm = (editors) => {
    setDescriptionEditors(editors);
  };

  const onFinishFailedFormInfo = (errorInfo) => {
    setLoading(false);
    setErrorTab([...errorTab, errorInfo]);
    toast.error("Vui lòng nhập đủ thông tin", {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
    });
  };

  const replaceEditor = () => {
    const shortDescription =
      descriptionEditors.shortDescription?.current.getContent() || "";
    let descriptionData =
      descriptionEditors.description?.current.getContent() || "";
    const ingredient =
      descriptionEditors.ingredient?.current.getContent() || "";
    const use = descriptionEditors.use?.current.getContent() || "";

    if (descriptionData !== "") {
      descriptionData = descriptionData.replaceAll(
        `${ENV.CDN_URL}`,
        `${ENV.IMAGE_VARIABLE}`
      );
    }
    const data = {
      shortDescription: shortDescription,
      description: descriptionData,
      ingredients: ingredient,
      use: use,
      images: fileImages,
    };
    console.log("replaceEditor", descriptionData);
    setProductInfo({
      ...productInfo,
      ...data,
    });
  };

  const resetSubmit = () => {
    setLoading(false);
    setDataCount(0);
    setStartSubmit(false);
  };

  const submitAll = () => {
    refInfo.current.submit();
    refPrice.current.submit();
    refAttribute.current.submit();
    refSeo.current.submit();
  };

  const createdProduct = () => {
    productApi.createProduct(productInfo).then(
      (res) => {
        setLoading(false);
        // console.log("res", res);
        if (!res.code) {
          Swal.fire({
            title: "Thành Công!",
            text: "Thêm sản phẩm thành công!",
            icon: "success",
            confirmButtonText: "OK",
          });
          resetSubmit();
          goToPreviousPath();
        } else {
          resetSubmit();
          Swal.fire({
            title: "Thất bại!",
            text: res.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
      (err) => {
        resetSubmit();
        // console.log("err", err);
        Swal.fire({
          title: "Thất bại!",
          text: err.response?.data?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  };

  const updateProduct = () => {
    productApi.updateProduct(id, productInfo).then(
      (res) => {
        setLoading(false);
        if (!res.code) {
          Swal.fire({
            title: "Thành Công!",
            text: "Sửa sản phẩm thành công!",
            icon: "success",
            confirmButtonText: "OK",
          });
          resetSubmit();
          goToPreviousPath();
        } else {
          resetSubmit();
          Swal.fire({
            title: "Thất bại!",
            text: res.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
      (err) => {
        resetSubmit();
        // console.log("err", err);
        Swal.fire({
          title: "Thất bại!",
          text: err.response?.data?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  };

  return (
    <>
      <Row gutter={[24, 24]}>
        <Col span={24} md={24} className="mb-24">
          <Card
            className="header-solid h-full"
            bordered={false}
            title={<h6 className="font-semibold m-0">Thêm sản phẩm mới</h6>}
            extra={
              <>
                <Space>
                  <Button
                    type="primary"
                    icon={<AiFillCheckCircle />}
                    onClick={() => {
                      setDataCount(0);
                      submitAll();
                      setLoading(true);
                    }}
                  >
                    &nbsp;Lưu
                  </Button>

                  <Button
                    type="danger"
                    icon={<AiFillCloseSquare />}
                    onClick={() => {
                      back();
                    }}
                  >
                    &nbsp;Hủy
                  </Button>
                </Space>
              </>
            }
            bodyStyle={{ paddingTop: "0" }}
          >
            <Divider />

            <Tabs tabPosition={tabPosition}>
              <TabPane
                tab={
                  <span
                    style={{ fontSize: 16 }}
                    className={
                      errorTab.length > 0 &&
                      errorTab.find((x) => x.name === "ProductInfo")
                        ? "error-tab"
                        : ""
                    }
                  >
                    <AiFillEdit />
                    &nbsp; Thông tin
                  </span>
                }
                key="ProductInfo"
              >
                <ProductInfo
                  ref={refInfo}
                  onSubmit={dataFormInfo}
                  onFinishFailed={onFinishFailedFormInfo}
                  productItem={productItem}
                />
              </TabPane>
              <TabPane
                forceRender={true}
                tab={
                  <span style={{ fontSize: 16 }}>
                    <AiOutlineInfoCircle />
                    &nbsp; Mô tả
                  </span>
                }
                key="ProductDescriptions1"
              >
                <ProductDescriptions
                  onInit={descriptionForm}
                  productItem={productItem}
                />
              </TabPane>
              <TabPane
                forceRender={true}
                tab={
                  <span
                    style={{ fontSize: 16 }}
                    className={
                      errorTab.length > 0 &&
                      errorTab.find((x) => x.name === "ProductPrice")
                        ? "error-tab"
                        : ""
                    }
                  >
                    <MdAttachMoney />
                    &nbsp; Giá
                  </span>
                }
                key="ProductPrice"
              >
                <ProductPrice
                  ref={refPrice}
                  onSubmit={dataFormInfo}
                  onFinishFailed={onFinishFailedFormInfo}
                  productItem={productItem}
                />
              </TabPane>

              <TabPane
                forceRender={true}
                tab={
                  <span
                    style={{ fontSize: 16 }}
                    className={
                      errorTab.length > 0 &&
                      errorTab.find((x) => x.name === "ProductPriceAttribute")
                        ? "error-tab"
                        : ""
                    }
                  >
                    <MdOutlinePriceCheck />
                    &nbsp; Giá thuộc tính
                  </span>
                }
                key="ProductPriceAttribute"
              >
                <ProductPriceAttribute
                  ref={refAttribute}
                  onSubmit={dataFormInfo}
                  onFinishFailed={onFinishFailedFormInfo}
                  productItem={productItem}
                />
              </TabPane>

              {/* <TabPane
                tab={
                  <span style={{ fontSize: 16 }}>
                    <TbDiscount2 />
                    &nbsp; Khuyến mãi
                  </span>
                }
                key="3"
              >
                Khuyến mãi
              </TabPane> */}
              <TabPane
                tab={
                  <span style={{ fontSize: 16 }}>
                    <MdImage />
                    &nbsp; Hình ảnh
                  </span>
                }
                key="ProductMedia"
              >
                <ProductMedia
                  productItem={productItem}

                  // ref={refImage}
                  // onSubmit={dataFormInfo}
                  // onFinishFailed={onFinishFailedFormInfo}
                />
              </TabPane>
              <TabPane
                forceRender={true}
                tab={
                  <span style={{ fontSize: 16 }}>
                    <MdSearch />
                    &nbsp; SEO
                  </span>
                }
                key="ProductSeo"
              >
                <ProductSeo
                  ref={refSeo}
                  onSubmit={dataFormInfo}
                  onFinishFailed={onFinishFailedFormInfo}
                  productItem={productItem}
                />
              </TabPane>
            </Tabs>
          </Card>
        </Col>
      </Row>
      <ToastContainer />
    </>
  );
};

export default Product;
